import React from "react"
import { Container, Row, Col, Button, Form, Card } from "react-bootstrap"
import { Formik, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
import { cleanEntity } from "../../Common/js/clean_entity"
import Select from "react-select"
import * as CountryIcon from "country-flag-icons/react/3x2"
import withHooks from "../../Common/jsx/WithHooks"
import { getUser, patchUser, postUser } from "../../api/api_user"

class UserForm extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    // this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    // CONFIG ==================================================================================================
    let emptyEntity = {
      name: "",
      firstname: "",
      iamUsername: "",
      email: "",
      departments: [],
      preferredLanguage: "fr",
      roles: ["ROLE_RECEPTION"],
    }
    // /CONFIG =================================================================================================

    let entity
    let isReadyToRender
    if (this.props.entityId === undefined) {
      this.formType = "create"
      this.cardHeaderText = this.props.t("action.adding") + " " + this.props.t("entity." + this.props.entityType)
      entity = emptyEntity
      isReadyToRender = true
    } else {
      this.formType = "edit"
      this.cardHeaderText = this.props.t("action.editing") + " " + this.props.t("entity." + this.props.entityType) + " #" + this.props.entityId
      isReadyToRender = false
    }
    this.dMgr.debug("formType:", this.formType)

    this.state = {
      isReadyToRender: isReadyToRender,
      disable_button_validate: false,
      entity: entity,
      // CONFIG ==================================================================================================
      roles: ["ROLE_ADMIN"],
      // /CONFIG =================================================================================================
    }
    this.dMgr.debug("init_state:", this.state)

    this.getEntity = this.getEntity.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.lockAndSubmit = this.lockAndSubmit.bind(this)
    this.getFormValidationSchema = this.getFormValidationSchema.bind(this)
  }

  componentDidMount() {
    this.getEntity()
  }

  async getEntity() {
    if (this.props.entityId !== undefined) {
      // CONFIG ==================================================================================================
      let entity = await getUser(this.props.entityId)
      // /CONFIG =================================================================================================
      this.dMgr.debug("getEntity:", entity)
      this.setState({ entity, isReadyToRender: true })
    }
  }

  getFormValidationSchema() {
    // CONFIG ==================================================================================================
    return Yup.object().shape({
      firstname: Yup.string().required(this.props.t("message.required")),
      name: Yup.string().required(this.props.t("message.required")),
      email: Yup.string().email(this.props.t("message.required")).required(this.props.t("message.bgalidEmail")),
      // roles: Yup.array().of(Yup.string().oneOf(this.state.roles)),
    })
    // /CONFIG =================================================================================================
  }

  async lockAndSubmit(values, { setSubmitting }) {
    this.dMgr.debug("lockAndSubmit:", values)
    this.setState({ disable_button_validate: true }, () => this.handleSubmit(values, { setSubmitting }))
  }

  async handleSubmit(values, { setSubmitting }) {
    this.dMgr.debug("handleSubmit:", values)

    try {
      // CONFIG ==================================================================================================

      let entity = cleanEntity(values)

      this.dMgr.debug("cleanEntity:", entity)

      let newEntity = {}
      if (entity.id === undefined) {
        this.dMgr.debug("post entity:", entity)
        newEntity = await postUser(entity)
      } else {
        this.dMgr.debug("patch entity:", entity.id, entity)
        newEntity = await patchUser(entity.id, entity)
      }

      this.dMgr.debug("success entity:", newEntity.id, newEntity)
      this.props.notif.success()
      this.props.router.nav({
        prefix: "admin",
        entitiesType: this.props.entitiesType,
      })

      // /CONFIG =================================================================================================
    } catch (err) {
      this.dMgr.error("COUGHT EXCEPTION:", err)
      this.props.notif.failed(err)
    } finally {
      this.setState({ disable_button_validate: false })
      setSubmitting(false)
    }
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <Container>
        <Formik enableReinitialize initialValues={this.state.entity} validationSchema={this.getFormValidationSchema} onSubmit={this.lockAndSubmit}>
          {({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (
            <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Row>
                <Col md={3}></Col>
                <Col md={6}>
                  <Card className="bg-dark text-white box-shadow-lvl3">
                    <Card.Header>{this.cardHeaderText}</Card.Header>
                    <Card.Body>
                      {/* CONFIG ==================================================================================== */}
                      <Container fluid>
                        <Row>
                          <Col md={6}>
                            <Form.Group controlId="formFirstname">
                              <Form.Label>{this.props.t("form.firstname") + this.props.t("app.dbp")}</Form.Label>
                              <Field as={Form.Control} name="firstname" isInvalid={touched.firstname && errors.firstname} onChange={handleChange} value={values.firstname} />
                              <Form.Control.Feedback type="bgalid">
                                <ErrorMessage name="firstname" />
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group controlId="formName">
                              <Form.Label>{this.props.t("form.name") + this.props.t("app.dbp")}</Form.Label>
                              <Field as={Form.Control} name="name" isInvalid={touched.name && errors.name} onChange={handleChange} value={values.name} />
                              <Form.Control.Feedback type="bgalid">
                                <ErrorMessage name="name" />
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <br />
                        <Row>
                          <Col md={8}>
                            <Form.Group controlId="formEmail">
                              <Form.Label>{this.props.t("form.email") + this.props.t("app.dbp")}</Form.Label>
                              <Field as={Form.Control} name="email" isInvalid={touched.email && errors.email} onChange={handleChange} value={values.email} />
                              <Form.Control.Feedback type="bgalid">
                                <ErrorMessage name="email" />
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group controlId="formIAMUsername">
                              <Form.Label>{this.props.t("form.preferredLanguage") + this.props.t("app.dbp")}</Form.Label>
                              <Select
                                classNamePrefix="custom-react-select"
                                className={`react-select ${touched.preferredLanguage && errors.preferredLanguage ? "react-select-bgalid" : ""}`}
                                name="preferredLanguage"
                                options={Object.keys(this.props.i18n.options.availableLanguages).map((key) => {
                                  let IconCountry = CountryIcon[this.props.i18n.options.availableLanguages[key].flag]
                                  return {
                                    value: this.props.i18n.options.availableLanguages[key].lang,
                                    label: (
                                      <>
                                        <IconCountry className="lang_flag margin-right-5" />
                                      </>
                                    ),
                                  }
                                })}
                                defaultValue={
                                  values.preferredLanguage !== ""
                                    ? () => {
                                        // console.log("eeev", values.preferredLanguage);
                                        let IconCountry = CountryIcon[this.props.i18n.options.availableLanguages[values.preferredLanguage].flag]

                                        return {
                                          value: values.preferredLanguage,
                                          label: (
                                            <>
                                              <IconCountry className="lang_flag margin-right-5" />
                                            </>
                                          ),
                                        }
                                      }
                                    : ""
                                }
                                onChange={(e) => {
                                  setFieldValue("preferredLanguage", e.value)
                                }}
                              />
                              <Form.Control.Feedback type="bgalid">
                                {touched.preferredLanguage && errors.preferredLanguage && <div className="bgalid-feedback d-block">{errors.preferredLanguage}</div>}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <br />
                        <Row>
                          {/* ------------------------ ROLES */}
                          <Col md={4}>
                            <Form.Group controlId="formRoles">
                              <Form.Label>{this.props.t("form.roles") + this.props.t("app.dbp")}</Form.Label>
                              {this.state.roles.map((role, index) => (
                                <Form.Check
                                  id={`role-${index}`}
                                  key={`role-${index}`}
                                  type="checkbox"
                                  label={role}
                                  name="roles"
                                  value={role}
                                  checked={values.roles.includes(role)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setFieldValue("roles", [...values.roles, role])
                                    } else {
                                      setFieldValue(
                                        "roles",
                                        values.roles.filter((r) => r !== role),
                                      )
                                    }
                                  }}
                                />
                              ))}
                              {touched.roles && errors.roles && (
                                <div className="bgalid-feedback d-block">
                                  <ErrorMessage name="roles" />
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          {/* ------------------------ /ROLES */}
                        </Row>
                        <br />
                        <br />
                        <Row>
                          <Col md={4}></Col>
                          <Col md={2} className="text-center">
                            <Button
                              id="btn-cancel"
                              onClick={() =>
                                this.props.router.nav({
                                  url: this.props.router.location.state.referrerUrl,
                                })
                              }
                              variant="secondary"
                              size="sm"
                              className="margin-right-5"
                            >
                              {this.props.t("action.cancel")}
                            </Button>
                          </Col>
                          <Col md={2} className="text-center">
                            <Button id="btn-submit" variant="primary" size="sm" type="submit" disabled={this.state.disable_button_validate} className="margin-right-5">
                              {this.props.t("action.validate")}
                            </Button>
                          </Col>
                        </Row>
                      </Container>
                      {/* /CONFIG ================================================================================ */}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Container>
    )

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(UserForm)
